export const styles = {
  browseTemplateBox: {
    display: "flex",
    flexDirection: "column",
    fontSize: "1.4rem",
    fontWeight: 500,
    lineHeight: "2.1rem",
    backgroundColor: "var(--neutral-100)",
    borderRadius: "1.2rem",
    width: "max-content",
    transition: "all 0.3s ease-in-out",
    marginTop: "1rem",
    maxHeight: "22rem",
    overflow: "scroll",
  },

  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "0.8rem",
    padding: "1rem 2.5rem 1rem 1rem",
    cursor: "pointer",
    transition: "background-color 0.3s",
    borderBottom: "0.1rem solid var(--gray-200)",
    "&:not(:last-child)": {
      borderBottom: "0.1rem solid var(--gray-200)",
    },
    "&:hover": {
      backgroundColor: "var(--gray-200)",
    },
  },
  selectedItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "0.8rem",
    padding: "1rem 2.5rem 1rem 1rem",
    cursor: "pointer",
    transition: "background-color 0.3s",
    backgroundColor: "var(--warm-neutral-50)",
  },
  searchTemplateContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.1rem solid var(--gray-200)",
    borderRadius: "8px",
    px: 1,
    py: 0.5,
    cursor: "pointer",
    bgcolor: "var(--neutral-100)",
  },
};
